import Section from './Section'
import { Text } from './Text'

export default function Footer() {
  return (
    <div className={`flex w-full flex-col gap-y-8  bg-neutral-800 pb-8 pt-[60px]`}>
      <Section>
        <div className='flex flex-col md:flex-row items-start justify-between gap-x-[160px] gap-y-[44px] flex-wrap md:flex-nowrap'>
          <div className='flex-col items-start font-medium flex-1 hidden lg:flex gap-2'>
            <Text.BodyLarge className='text-white/50 text-nowrap'>
              The Brethren Assembly Dubai
            </Text.BodyLarge>
            <Text.Caption className='text-white/50'>
              Copyright 2024 All Rights Reserved
            </Text.Caption>
          </div>
          <Text.Caption className='flex flex-shrink-0 min-w-[200px] flex-col items-start font-medium'>
            <div className='uppercase font-bold text-white/40'>Address</div>
            <div className='self-stretch capitalize leading-[2] text-white/75 pt-3'>
              <span>
                <p>The Brethren Assembly Dubai</p>
                <p>Holy Trinity Church</p>
                <p>Opp to Iranian Club</p>
                <p>Oud Metha Road</p>
                <p>Dubai, UAE</p>
              </span>
            </div>
          </Text.Caption>
          <Text.Caption className='flex flex-col min-w-[200px] items-start font-medium'>
            <div className='font-bold uppercase leading-normal text-white/40'>QUICK LINKS</div>
            <div className='self-stretch capitalize leading-[2] text-white/75 pt-3 transition-colors'>
              <a href='/about' className='block hover:text-white '>
                Home
              </a>
              <a href='/about' className='block hover:text-white '>
                About Us
              </a>
              <a href='/gospel' className='block hover:text-white '>
                Gospel
              </a>
              {/* <a href='/explore' className='block hover:text-white '>
                Explore
              </a> */}
              <a href='/contact' className='block hover:text-white '>
                Contact Us
              </a>
            </div>
          </Text.Caption>
        </div>
      </Section>
      <div className='h-px flex-shrink-0 bg-white/5 lg:hidden' />
      <Section className='lg:hidden'>
        <Text.Caption className='text-white/50'>
          Copyright 2024 The Brethren Assembly Dubai.
        </Text.Caption>
      </Section>
    </div>
  )
}
